// DataGridPro look shared by the Reporting "Practice Comparison" table and the Launchpad
// "All practices · summary" table (one definition, no copies).
export const PRACTICE_COMPARISON_GRID_SX = {
    border: 'none',
    '& .MuiDataGrid-columnHeaders': {
        bgcolor: '#f8fafc',
        borderBottom: '1px solid #e2e8f0',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 600,
        fontSize: '12px',
        color: '#64748b',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    '& .MuiDataGrid-cell': {
        borderBottom: '1px solid #f1f5f9',
    },
    '& .MuiDataGrid-row:hover': {
        bgcolor: '#f8fafc',
    },
};

export default PRACTICE_COMPARISON_GRID_SX;
